import React from "react";
import { useApi, apiCall } from "../../api";
import { Input, InputGroup } from "../../Components/Form";
import _ from "lodash";
import { Content } from "../../Components/Page";
import { Cell, CellHead, Row, Table, TableBody, TableHead } from "../../Components/Table";
import { formatDatetime, formatDuration } from "../../Util/time";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { usePageTitle } from "../../Util/title";
import { NavLink } from "react-router-dom";

export function FleetCompHistory() {
  const [date, setDate] = React.useState("");
  const [time, setTime] = React.useState("");
  const [latestTimeLoaded, setLatestTimeLoaded] = React.useState(false);

  // Fetch the latest fleet time on mount
  React.useEffect(() => {
    if (!latestTimeLoaded) {
      apiCall("/api/history/fleet-comp/latest", {})
        .then((data) => {
          if (data && data.time) {
            const latestDate = new Date(data.time * 1000);
            const year = latestDate.getUTCFullYear();
            const month = String(latestDate.getUTCMonth() + 1).padStart(2, "0");
            const day = String(latestDate.getUTCDate()).padStart(2, "0");
            const hours = String(latestDate.getUTCHours()).padStart(2, "0");
            const minutes = String(latestDate.getUTCMinutes()).padStart(2, "0");
            
            setDate(`${year}-${month}-${day}`);
            setTime(`${hours}:${minutes}`);
            setLatestTimeLoaded(true);
          }
        })
        .catch((err) => {
          console.error("Failed to load latest fleet time:", err);
          setLatestTimeLoaded(true);
        });
    }
  }, [latestTimeLoaded]);

  const parsedDate = date && time ? new Date(`${date}T${time}Z`) : null;
  const parsedDateUnix = parsedDate ? parsedDate.getTime() / 1000 : null;

  const [result] = useApi(parsedDateUnix ? `/api/history/fleet-comp?time=${parsedDateUnix}` : null);

  usePageTitle("Fleet History");
  return (
    <Content>
      <h2>Fleet history lookup in Eve Time (GMT)</h2>
      <InputGroup>
        <Input type="date" value={date} onChange={(evt) => setDate(evt.target.value)} />
        <Input type="time" value={time} onChange={(evt) => setTime(evt.target.value)} />
      </InputGroup>
      {parsedDate ? (
        <div>
          <em>{parsedDate.toString()}</em>
        </div>
      ) : null}

      {result && <h2>Results</h2>}
      {result &&
        _.map(result.fleets, (comp, fleetId) => (
          <div key={fleetId}>
            <h3>Fleet {fleetId}</h3>
            <Table fullWidth>
              <TableHead>
                <Row>
                  <CellHead>Pilot</CellHead>
                  <CellHead>Ship</CellHead>
                  <CellHead>Time</CellHead>
                </Row>
              </TableHead>
              <TableBody>
                {_.orderBy(comp, ['logged_at'], ['asc']).map((entry) => (
                  <Row key={entry.character.id}>
                    <Cell>
                      <NavLink to={`/fc/search?query=${encodeURIComponent(entry.character.name)}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {entry.character.name}
                      </NavLink>
                      {entry.is_boss && (
                        <>
                          {" "}
                          <FontAwesomeIcon icon={faStar} />
                        </>
                      )}
                    </Cell>
                    <Cell>{entry.hull.name}</Cell>
                    <Cell>
                      {formatDatetime(new Date(entry.logged_at * 1000))} (
                      {formatDuration(entry.time_in_fleet)})
                    </Cell>
                  </Row>
                ))}
              </TableBody>
            </Table>
          </div>
        ))}
      {result && _.isEmpty(result.fleets) && <em>Nothing found!</em>}
    </Content>
  );
}
